<template>
  <div>
    <div class="holder">
      <h2 id="page-header"><router-link to="/">My Arlington</router-link></h2>
      <div id="blurb">
        <p>
          Engage and Explore with your County Government
        </p>
        <br/>
      </div>
    </div>
    <div class="layer-page">
      <div class="widget" style="margin: 0 8px">
        <div>
          <h3>
            <router-link to="/apartments">Apartments/Condos</router-link>
          </h3>
        </div>
        <br/><br/>
        <div>
          <h3>
            <router-link to="/childcareprograms">Child Care Availability</router-link>
          </h3>
        </div>
        <br/><br/>
        <div>
          <h3>
            <router-link to="/digitalresources">Digital Resources</router-link>
          </h3>
        </div>
        <br/><br/>
        <div>
          <h3>
            <router-link to="/parkaccessibility">Filter Park Amenities to Find a Park that Fits your Needs</router-link>
          </h3>
        </div>
        <br/><br/>
        <div>
          <h3>
            <router-link to="/foodresources">Food Resources</router-link>
          </h3>
        </div>
        <br/><br/>
         <div>
          <h3>
            <router-link to="/map/voter">Voter Turnout</router-link>
          </h3>
          </div>
        <br/><br/>
          <div>
          <h3>
            <router-link to="/map/long-term-care">Long-term Care Communities</router-link>
          </h3>
          </div>
        <br/><br/>
          <div>
          <h3>
            <router-link to="/polling">Polling Place Locator</router-link>
          </h3>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

}

</script>



// WEBPACK FOOTER //
// Home.vue?1c772faf